// @flow
import moment from "moment";
import memoizeOne from "memoize-one";
import deepEqual from "lodash/isEqual";

type News = Array<{
  title: string,
  createdAt: string,
  slug: string,
  publishedAt?: null | string
}>;

function reducedNews(news: News) {
  if (Array.isArray(news)) {
    return news.reduce((acc, news) => {
      const date = moment(
        news.publishedAt != null ? news.publishedAt : news.createdAt,
        moment.ISO_8601
      );
      const news_obj = {
        type: "news",
        timestamp: date.valueOf() / 1000,
        news
      };

      acc.push(news_obj);

      return acc;
    }, []);
  }

  return [];
}

type AllNewsProps = {
  news: News,
  lastViewTimestamp: Number
};

export function allNews(props: AllNewsProps) {
  const reducedNewsCached = memoizeOne(reducedNews, deepEqual);

  const { news, lastViewTimestamp } = props;

  // приводим в порядок новости
  const reduced_news = reducedNewsCached(news);
  const latest_news = reduced_news.filter(news => {
    const date = moment.unix(news.timestamp);
    const sevenDaysAgo = moment().subtract(7, "days");

    return date.isAfter(sevenDaysAgo);
  });

  const new_news_count = latest_news.reduce((acc, item) => {
    const time = moment.unix(item.timestamp);
    const lastViewTime = moment.unix(lastViewTimestamp);

    if (time.isAfter(lastViewTime) || time.isSame(lastViewTime)) {
      acc++;
    }

    return acc;
  }, 0);

  return new_news_count;
}



// WEBPACK FOOTER //
// ./src/components/Bell/helpers.js